import { create } from "zustand";

export interface AppState {
  isGolffixApp: boolean | null;
  isIOSInapp: boolean;
  isAndroidInapp: boolean;
  userAgent: string;
  isScrollAtTopForNative: boolean;
}

interface AppActions {
  setIsGolffixApp: (isGolffixApp: boolean) => void;
  setIsIOSInapp: (isIOSInapp: boolean) => void;
  setIsAndroidInapp: (isAndroidInapp: boolean) => void;
  setUserAgent: (userAgent: string) => void;
  setIsScrollAtTopForNative: (isScrollAtTopForNative: boolean) => void;
}

const useAppStateStore = create<AppState & AppActions>(
  (
    set: (arg0: {
      isGolffixApp?: boolean;
      isIOSInapp?: boolean;
      isAndroidInapp?: boolean;
      userAgent?: string;
      isScrollAtTopForNative?: boolean;
    }) => void
  ) => ({
    isGolffixApp: null,
    isIOSInapp: false,
    isAndroidInapp: false,
    userAgent: "",
    isScrollAtTopForNative: true,
    setIsGolffixApp: (isGolffixApp: boolean) => set({ isGolffixApp }),
    setIsIOSInapp: (isIOSInapp: boolean) => set({ isIOSInapp }),
    setIsAndroidInapp: (isAndroidInapp: boolean) => set({ isAndroidInapp }),
    setUserAgent: (userAgent: string) => set({ userAgent }),
    setIsScrollAtTopForNative: (isScrollAtTopForNative: boolean) =>
      set({ isScrollAtTopForNative }),
  })
);

export default useAppStateStore;
